import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import Slider from "react-slick";

const PrevButton = ({ onClick }) => (
  <i className="fa fa-arrow-left btn-prev" onClick={onClick} />
);

const NextButton = ({ onClick }) => (
  <i className="fa fa-arrow-right btn-next" onClick={onClick} />
);

const SlickSlider = ({ arrowsVersion, ...sliderProps }) => {
  if (arrowsVersion) {
    sliderProps.prevArrow = <PrevButton />;
    sliderProps.nextArrow = <NextButton />;
    sliderProps.className = cn(sliderProps.className, {
      [`arrows-${arrowsVersion}`]: arrowsVersion,
    });
  }

  return <Slider {...sliderProps} />;
};

PrevButton.propTypes = NextButton.propTypes = {
  onClick: PropTypes.func,
};

SlickSlider.propTypes = {
  arrowsVersion: PropTypes.string,
};

export default SlickSlider;
